var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('GoogleLogin',{attrs:{"params":_vm.params,"renderParams":_vm.renderParams,"onSuccess":_vm.onSuccess,"logoutButton":false}},[_vm._v("Google Login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }